import React, { Suspense, useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';
import directoryServices from '../directoryServices';
import { CommonUtilities } from '../../../commonUtils';
import Pagination from '../../Header/Pagination';

export default function SqlCheckDetail(param: any) {

    let [totalRows, setTotalRows] = useState(0);
    let [SearchFor, setSearchFor] = useState("");
    let [execHeader, setexecHeader] = useState<any>([]);
    let [execListing, setexecListing] = useState<any>([]);
    let [execTempListing, setexecTempListing] = useState<any>([]);

    useEffect(() => {

        if (param.open) {
            console.log(param)
            SearchResult();
        }

    }, [param])

    const Data: any = { pageNumber: 1, pageSize: 10 }

    const handleNameOnChange = (n: any) => {
        Data.pageNumber = n.pageNumber;
        Data.pageSize = n.pageSize;
        //SearchResult();

        var obj = execTempListing.slice((Data.pageNumber - 1) * Data.pageSize, Data.pageSize * Data.pageNumber);
        setexecListing(obj)
    }

    const SearchResult = () => {

        var Invoicepayload = { Type: "accountSQLCheckDetail", AccountCode: param?.selectedDetail?.accountCode, SQLErrorName: param?.selectedDetail?.errorName }
        directoryServices.genericAPIListing(Invoicepayload).then((values: any) => {
            setexecListing(CommonUtilities.relativeDataRemapping(values.data, values.headers.original).slice((Data.pageNumber - 1) * Data.pageSize, Data.pageSize * Data.pageNumber))
            setexecTempListing(CommonUtilities.relativeDataRemapping(values.data, values.headers.original))
            setTotalRows(values.totalRows);

            execHeader = [];
            Object.entries(values.headers.display).forEach(([key, value]) => { execHeader.push(value) });
            setexecHeader(execHeader);
            console.log(CommonUtilities.relativeDataRemapping(values.data, values.headers.original))

        })

    }


    const ContainerClose = (e: any) => {

        param.onCloseSqlCheck();
    }

    const exportDataSet =() =>{

        console.log( "working ")

    }



    return (<>

        <Drawer open={param.open}
            onClose={() => ContainerClose}
            direction='right'
            className='react-drawer-left  allowVscroll allowHscroll'
            style={{ width: "100%" }}>

            <div className="box ws-8 pull-right noBorderRadius noBorder">

                <div className="box-header-main">
                    <h2> {param?.selectedDetail?.errorName} ( {param?.selectedDetail?.accountCode})</h2>
                </div>

                <div className='box-content ws-12'>

                    <div className="ws-12 text-bold mbl">
                        <span className="pull-left mt">Showing ( {totalRows} ) results </span>
                    </div>

                    <div className="ws-12 pull-left pll">

                        <div className="table-responsive mrl allowVscroll">

                            <table className="table mbxl mtl">
                                <tr>
                                    {execHeader.map((values: any, index: any) => {
                                        if (values !== 'totalRow' && values !== 'rowNumber') { return (<> <th> {CommonUtilities.headerName(values)} </th> </>) }
                                    })}
                                </tr>

                                {execListing.map((value: any) => {
                                    return (<>
                                        <tr>
                                            {execHeader.map((Hvalues: any, index: any) => {
                                                if (Hvalues !== 'totalRow' && Hvalues !== 'rowNumber') { return (<> <td> {value[Hvalues.replace(/\s+/g, '')]} </td> </>) }
                                            })}
                                        </tr>
                                    </>)
                                })}
                            </table>
                        </div>

                        <div className="ws-12">
                            {(() => {
                                if (totalRows && totalRows > 10) {
                                    return  <Pagination onPageChange={handleNameOnChange} totalRow={totalRows} />
                                }
                            })()}
                        </div>
                    </div>

                </div>

                <div className="ws-12 footer prl pll ptl pbl">
                    <button className="icon-btn primary pull-right"onClick={() => exportDataSet()        }>Export </button>
                    <button className="icon-btn delete pull-right" onClick={() => ContainerClose("Close")}>Close  </button>
                </div>

            </div>


        </Drawer>
    </>)

}